import {
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewChild,
    EventEmitter,
    Output,
    ElementRef,
    ChangeDetectionStrategy,
    OnDestroy,
    computed,
    ViewEncapsulation,
    inject,
    signal,
} from "@angular/core";
import { ModalDialogParams } from "../../../../modal/modals/modal.dialog.component";
import { S25LoadingInlineModule } from "../../../../s25-loading/s25.loading.inline.module";
import { S25ModalModule } from "../../../../s25-modal/s25.modal.module";
import { S25ObjectSearchModule } from "../../../../s25-object-search/s25.object.search.module";
import { S25ConflictsModule } from "../../../../s25-conflicts/s25.conflicts.module";
import { EventOccUtil } from "../s25.event.occurrence.util";
import { S25ModalComponent } from "../../../../s25-modal/s25.modal.component";
import { S25ReservationUtil } from "../../../utils/s25.reservation.util";
import { S25RmReservationUtil } from "../../../utils/s25.rm.reservation.util";
import { S25Util } from "../../../../../util/s25-util";
import { TypeManagerDecorator } from "../../../../../main/type.map.service";
import { S25EventOccurrencesService } from "../../s25.event.occurrences.service";
import { ModalService } from "../../../../modal/modal.service";
import { S25LoadingApi } from "../../../../s25-loading/loading.api";
import { Item } from "../../../../../pojo/Item";
import { EventDataMicroI } from "../../../EventMicroI";
import { EventMicroService } from "../../../../../services/event.micro.service";
import {
    ObjectSearchRefresh,
    S25ObjectSearchComponent,
} from "../../../../s25-object-search/s25.object.search.component";
import { AvailLocationItems, AvailResourceItems } from "../../../../s25-object-search/s25.object.search.util";
import { ObjectSearchAvail } from "../../../../s25-object-search/object.search.avail";
import { S25Reservation, S25RmReservation } from "../../../ReservationI";
import {
    confirmBoundEventLocationChangeForOccurrence,
    getProfileReservationsForBoundLocationPrompt,
} from "../../../utils/bound.event.location.util";
import { S25Event } from "../../../EventMicroI";
import { S25Profile } from "../../../ProfileI";
import { S25EventShareDataService } from "../../s25.event.shared.data.service";
import { Subscription } from "rxjs";
import { NotificationService } from "../../../../../services/notification.service";
import { TelemetryService } from "../../../../../services/telemetry.service";
import { Event } from "../../../../../pojo/Event";
import Rsrv = Event.Reservation.States;
import { S25ItemI } from "../../../../../pojo/S25ItemI";
import { S25ProfileUtil } from "../../../utils/s25.profile.util";
import { FlsService } from "../../../../../services/fls.service";
import { Fls } from "../../../../../pojo/Fls";
import { RecordType } from "../../../ProfileI";
import { OccurrenceAdditionalDetailsComponent } from "./occurrence-additional-details/occurrence.additional.details.component";
import { S25TriggerRerenderModule } from "../../../../s25-trigger-rerender/s25.trigger.rerender.module";
import { SpaceConflictErrorUtil } from "../../../utils/space.conflict.error.util";
import { AvailCheck } from "../../../../../pojo/AvailabilityCheck";

@TypeManagerDecorator("occurrence-action")
@Component({
    selector: "occurrence-action",
    template: `
        @if (init) {
            @if (eventState === 98 || eventState === 99) {
                <div>None</div>
            }

            @if (eventState !== 98 && eventState !== 99) {
                <div class="occ-action-wrapper">
                    <div>
                        <select
                            class="cn-form__control"
                            aria-label="Occurrence State"
                            (change)="onChangeActive($event, $safeNavigationMigration(occurrence()?.state))"
                        >
                            @for (state of rsrvStates; track state.itemId) {
                                <option [value]="state.itemId" [selected]="occurrence()?.state === state.itemId">
                                    {{ state.itemName }}
                                </option>
                            }
                        </select>
                    </div>
                    <div class="occ-action-buttons">
                        <button
                            class="aw-button aw-button--outline"
                            (click)="onActionCopy()"
                            [disabled]="occurrence()?.state === 99 || occurrence()?.state === 2"
                        >
                            Copy
                        </button>
                        @if (!singleRsrv) {
                            <button class="aw-button aw-button--danger--outline" (click)="onActionDelete()">
                                Delete
                            </button>
                        }
                        <button
                            class="aw-button aw-button--outline"
                            (click)="onObjectSearch(4)"
                            [disabled]="locSearchDisabled"
                        >
                            Add Locations
                        </button>
                        <button
                            class="aw-button aw-button--outline"
                            (click)="onObjectSearch(6)"
                            [disabled]="resSearchDisabled"
                        >
                            Add Resources
                        </button>
                    </div>

                    <s25-loading-inline [model]="{}" class="c-margin-top--single"></s25-loading-inline>
                </div>
                <s25-ng-modal
                    #objectSearchModal
                    class="object-search-modal"
                    [title]="itemTypeId === 4 ? 'Locations Search' : 'Resources Search'"
                    [size]="'xl'"
                >
                    <ng-template #s25ModalBody>
                        <s25-ng-object-search
                            #objectSearchComponent
                            [itemTypeId]="itemTypeId"
                            [occ]="occurrence()"
                            [profileId]="profileId"
                            [eventId]="eventId"
                            [selectedItems]="accuUpdateItems"
                            [event]="event()!"
                            [expectedCount]="expectedCount"
                            (refreshF)="onRefresh($event)"
                            (cancelled)="objectSearchModal.close()"
                        />
                    </ng-template>
                </s25-ng-modal>

                <s25-ng-modal #copyOccModal [title]="'Copy Occurrence'" [size]="'xl'">
                    <ng-template #s25ModalBody>
                        @if (copyOcc) {
                            <ng-container *s25-ng-trigger-rerender="copyOccRenderKey">
                                <occurrence-additional-details
                                    [occ]="copyOcc"
                                    [mode]="'copy'"
                                    [canEdit]="!!canEdit"
                                    [editMode]="true"
                                    [eventId]="eventId"
                                    [profileId]="profileId"
                                    [copyInitOcc]="initOcc"
                                    (onCancel)="cancel()"
                                    (onSave)="copyOccModal.close(); refreshF.emit()"
                                />
                            </ng-container>
                        }
                    </ng-template>
                </s25-ng-modal>

                <s25-ng-modal #spaceConflictModal [title]="'Conflicts'" [size]="'md'">
                    <ng-template #s25ModalBody>
                        <p class="c-margin-bottom--half">{{ spaceConflictMessage() }}</p>
                        <s25-ng-conflicts [model]="displayConflicts()"></s25-ng-conflicts>
                    </ng-template>
                </s25-ng-modal>
            }
        }
    `,
    styles: [
        `
            :host {
                display: block;
                max-width: 235px;
            }

            .occ-action-wrapper {
                display: flex;
                flex-direction: column;
                gap: 5px;
                width: 100%;
                max-width: 235px;

                select {
                    width: 96%;
                }

                .occ-action-buttons {
                    display: grid;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    gap: 5px;

                    button {
                        width: 100%;
                        min-width: 0;
                    }
                }
            }
            /* TODO: delete this after we add a way to mark modals as non-scrolling */
            .object-search-modal {
                .s25-modal--body {
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        S25LoadingInlineModule,
        S25ModalModule,
        S25ObjectSearchModule,
        S25ConflictsModule,
        OccurrenceAdditionalDetailsComponent,
        S25TriggerRerenderModule,
    ],
})
export class OccurrenceActionComponent implements OnDestroy, OnInit {
    @Input() occ: S25Reservation;
    @Input() eventState: number;
    @Input({ required: true }) eventId: number;
    @Input() canEdit?: number;
    @Input() profileId?: number;
    @Input() singleRsrv?: boolean; // if single Rsrv no delete button
    @Input() selectedItems?: number[] = [];
    @Input() hasPerm?: boolean;
    @ViewChild("copyOccModal") copyOccModal: S25ModalComponent;
    @ViewChild("objectSearchModal") objectSearchModal: S25ModalComponent;
    @ViewChild("objectSearchComponent") objSearchComp: S25ObjectSearchComponent;
    @ViewChild("spaceConflictModal") spaceConflictModal?: S25ModalComponent;

    @Output() refreshF = new EventEmitter<void>();

    private readonly occurrencesService = inject(S25EventOccurrencesService);
    private readonly elementRef = inject(ElementRef);
    private readonly cd = inject(ChangeDetectorRef);
    private readonly shareDataService = inject(S25EventShareDataService, { skipSelf: true });

    initOcc: S25Reservation;
    copyOcc?: S25Reservation;
    copyOccRenderKey = 0;
    itemTypeId: Item.Ids.Location | Item.Ids.Resource;
    accuUpdateItems: number[] = [];

    init: boolean = false;
    private selectedItemsSubscription: Subscription;

    readonly event = this.occurrencesService.S25Event;
    readonly displayConflicts = signal<AvailCheck.ConflictDefaults[]>([]);
    readonly spaceConflictMessage = signal(SpaceConflictErrorUtil.DEFAULT_SUMMARY_MESSAGE);
    occurrence = computed(
        () => this.occurrencesService.getOccurrences().find((rsrv) => rsrv.itemId === this.occ.itemId)!,
    );

    rsrvStates: S25ItemI[] = [];
    profileCode?: string = undefined;
    expectedCount?: number;
    fls: Fls;
    locSearchDisabled: boolean = false;
    resSearchDisabled: boolean = false;

    async ngOnInit() {
        this.fls = await FlsService.getFls();
        this.initOcc = S25Util.deepCopy(this.occurrence());
        this.selectedItemsSubscription = this.shareDataService.getSelectedItems().subscribe((items) => {
            this.selectedItems = items;
        });
        this.rsrvStates = await S25ReservationUtil.getRsrvState(this.occ.state);
        this.profileCode = this.profileId
            ? S25ProfileUtil.getProfileCode(this.occurrencesService.getProfiles(), this.profileId)
            : undefined;
        this.hasPerm = S25ReservationUtil.checkObjHasPerm(this.occurrencesService.getOccurrences());
        const event = this.event();
        if (event?.profile) {
            const profile = S25ProfileUtil.getProfileByRsrvId(event.profile, this.occ?.itemId);
            if (profile?.expectedCount != null) this.expectedCount = profile.expectedCount;
        }
        this.setSearchButtons();
        this.init = true;
        this.cd.detectChanges();
    }

    async onActionCopy() {
        this.copyOcc = await EventOccUtil.copyOcc(this.occurrence());
        this.copyOccRenderKey++;
        this.cd.detectChanges();
        this.copyOccModal.open();
    }

    async onObjectSearch(id: number) {
        this.accuUpdateItems = Object.values(S25Util.clone(this.selectedItems));
        if (!this.accuUpdateItems.includes(this.occurrence().itemId))
            this.accuUpdateItems.push(this.occurrence().itemId);
        this.itemTypeId = id;
        this.objectSearchModal.open();
    }

    async onActionDelete() {
        const dialogData = ModalService.dialogType(
            "Yes No",
            {
                message: "Are you sure you want to delete this occurrence?",
                title: "Confirm Deletion",
            },
            "No",
        );
        await ModalService.modal("dialog", dialogData);
        if (dialogData.answer !== ModalDialogParams.Answer.Yes) return;

        if (this.profileCode) {
            const patternDialogData = ModalService.dialogType(
                "Continue Cancel",
                {
                    message:
                        "With deleting the reservation, the segment will no longer have a repeating pattern,  cancel the reservation instead of deleting to maintain the repeating pattern.",
                    title: "Confirm Deletion",
                },
                "Cancel",
            );
            await ModalService.modal("dialog", patternDialogData);
            if (patternDialogData.answer !== ModalDialogParams.Answer.Yes) return;
        }
        return this.save(true);
    }

    async onChangeActive(e: any, oldVal: number) {
        const newVal = parseInt(e.target.value);
        const payload: EventDataMicroI = {
            items: [
                {
                    kind: "event",
                    id: this.eventId,
                    profiles: [
                        {
                            profileId: this.profileId,
                            reservations: [
                                {
                                    rsrvId: this.occ.itemId, //rsrvId
                                    state: newVal,
                                },
                            ],
                        },
                    ],
                },
            ],
        }; //end payload

        if (newVal === Rsrv.Cancelled) {
            const dialogData = ModalService.dialogType(
                "Yes No",
                {
                    message: "Are you sure you want to cancel this occurrence?",
                    title: "Confirm Cancelled",
                },
                "No",
            );

            await ModalService.modal("dialog", dialogData);
            if (dialogData.answer !== ModalDialogParams.Answer.Yes) {
                this.init = false;
                this.cd.detectChanges();
                this.init = true;
                this.cd.detectChanges();
                return; // User answered no or cancelled
            }
        }

        S25ReservationUtil.setState(this.occurrence(), newVal);
        this.setLoading(true);
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", "EditMode");
        const [ok, error] = await S25Util.Maybe(
            this.occurrencesService.runInlineEditScenarios(this.eventId, () =>
                EventMicroService.putEventReservation(this.eventId, payload),
            ),
        );
        this.setLoading(false);
        if (ok) {
            if (ok?.content?.errors) {
                for (const error of ok?.content?.errors) {
                    NotificationService.post(error.message);
                }
            } else {
                this.refreshF.emit();
            }
        }
        if (error) return S25Util.showError(error, "There was an error while attempting to update this reservation.");
    }

    cancel() {
        this.copyOcc = undefined;
        this.copyOccModal.close();
        this.cd.detectChanges();
    }

    async save(isDeleted: boolean) {
        const occ = this.occurrence();
        if (!occ) return;
        const event = this.occurrencesService.S25Event()!;
        const normalizeSaveData = EventOccUtil.normalizeEventWSData(event, occ, false, isDeleted, false);
        const data = normalizeSaveData[0].data;
        if (isDeleted && data.items[0].profiles?.length) {
            if (data.items[0].profiles[0].occurrenceDefn?.recTypeId !== RecordType.SingleDateTime)
                delete data.items[0].profiles[0].reservations;
            data.items[0].profiles[0].remove = { reservations: [{ rsrvId: occ.itemId }] };
        }

        this.setLoading(true);
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", isDeleted ? "DeleteOccurrence" : "EditMode");
        const [ok, error] = await S25Util.Maybe(
            this.occurrencesService.runInlineEditScenarios(this.eventId, () =>
                EventMicroService.microPutEventDetail(data, this.eventId),
            ),
        );
        this.setLoading(false);
        if (ok) {
            this.occurrencesService.requestRefresh();
        }
        if (error) return S25Util.showError(error, "There was an error while attempting to update this reservation.");
    }

    async onRefresh(output: ObjectSearchRefresh) {
        const namePlural = this.itemTypeId === Item.Ids.Location ? "spaces" : "resources";

        if (
            this.itemTypeId === Item.Ids.Location &&
            !(await confirmBoundEventLocationChangeForOccurrence(
                "add",
                this.eventId,
                this.profileId,
                getProfileReservationsForBoundLocationPrompt(this.occurrencesService.S25Event(), this.profileId),
                this.accuUpdateItems,
            ))
        ) {
            this.objSearchComp?.searchResultsList()?.revertPendingAddButtons(output.items);
            return;
        }

        const saved = output.profileRange
            ? await this.saveProfile(output.items, namePlural, output.profileRange.setup, output.profileRange.takedown)
            : await this.saveItems(output.items, namePlural);

        if (saved) this.objectSearchModal.close();
    }

    private async saveItems(items: ObjectSearchAvail.AddedItem[], namePlural: string): Promise<boolean> {
        const reservations = this.accuUpdateItems.map((rsrvId) => ({
            rsrvId,
            [namePlural]: items,
        }));

        const payload: EventDataMicroI = {
            items: [
                {
                    kind: "event",
                    id: this.eventId,
                    profiles: [{ profileId: this.profileId, reservations }],
                },
            ],
        };

        this.setLoading(true);
        TelemetryService.sendWithSub(
            "EventDetails",
            "EventDetailsOcc",
            this.itemTypeId === Item.Ids.Location ? "OccAddLoc" : "OccAddRes",
        );
        const [ok, error] = await S25Util.Maybe(
            this.occurrencesService.runInlineEditScenarios(this.eventId, () =>
                EventMicroService.putEventReservation(this.eventId, payload),
            ),
        );
        this.setLoading(false);

        if (ok) {
            if (ok?.content?.errors || ok?.content?.messages) {
                for (const err of ok.content.errors || ok.content.messages) {
                    NotificationService.post(err.message);
                }
            }
            this.refreshF.emit();
            return true;
        }
        if (error) {
            const addedLocations = items
                .filter((item): item is ObjectSearchAvail.AddedLocation => "spaceId" in item)
                .map((item) => ({ itemId: item.spaceId, itemName: item.spaceName }));
            if (await this.handleSpaceConflictError(error, undefined, addedLocations)) return false;
            S25Util.showError(error, "There was an error while attempting to add an item.");
            return false;
        }
        return false;
    }

    private async saveProfile(
        items: ObjectSearchAvail.AddedItem[],
        namePlural: string,
        setup: string,
        takedown: string,
    ): Promise<boolean> {
        const liveEvent: S25Event = this.occurrencesService.S25Event()!;
        const liveProfile: S25Profile = liveEvent.profile?.find((p) => p.itemId === this.profileId)!;
        if (!liveProfile) return false;

        const initAddedTime = S25Util.clone(liveProfile?.occurrenceDefn?.addedTime);
        const workingProfile = S25Util.clone(liveProfile);
        workingProfile.occurrenceDefn!.addedTime = { setup, takedown };

        const eventForSave: S25Event = {
            ...liveEvent,
            profile: [workingProfile],
        };

        const normalizeData = await S25ProfileUtil.normalizeProfileWSData(eventForSave, eventForSave.profile);
        const data = normalizeData[0].data;

        data.items![0].profiles![0].reservations = this.accuUpdateItems.map((rsrvId) => ({
            rsrvId,
            [namePlural]: items,
        }));

        this.setLoading(true);
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", "EditMode");
        const [ok, error] = await S25Util.Maybe(
            this.occurrencesService.runInlineEditScenarios(liveEvent.itemId, () =>
                EventMicroService.microPutEventDetail(data, liveEvent.itemId),
            ),
        );
        this.setLoading(false);

        if (ok) {
            if (ok?.content?.errors || ok?.content?.messages) {
                for (const err of ok.content.errors || ok.content.messages) {
                    NotificationService.post(err.message);
                }
            }
            this.occurrencesService.getEvent(liveEvent.itemId, false, ok);
            this.refreshF.emit();
            return true;
        }
        if (error) {
            // Restore only if live profile was never mutated (we work on a clone); keep for safety if clone failed
            if (liveProfile.occurrenceDefn) liveProfile.occurrenceDefn.addedTime = initAddedTime;
            const addedLocations = items
                .filter((item): item is ObjectSearchAvail.AddedLocation => "spaceId" in item)
                .map((item) => ({ itemId: item.spaceId, itemName: item.spaceName }));
            if (await this.handleSpaceConflictError(error, liveProfile, addedLocations)) return false;
            S25Util.showError(error, "There was an error while attempting to update this profile.");
            return false;
        }
        return false;
    }

    /** ANG-7691: show conflicting event name/date(s) instead of a generic toast on space conflict PUT errors. */
    private async handleSpaceConflictError(
        error: unknown,
        profile?: S25Profile,
        addedLocations: { itemId?: number; itemName?: string }[] = [],
    ): Promise<boolean> {
        const reservations: S25Reservation[] =
            (profile?.reservations as S25Reservation[] | undefined) ??
            S25Util.array.forceArray(this.occurrence()) ??
            [];
        const locations = [
            ...addedLocations,
            ...reservations.flatMap((rsrv) =>
                rsrv.locations?.length
                    ? S25RmReservationUtil.getLocationsFlat(rsrv.locations[0] as S25RmReservation)
                    : [],
            ),
        ];
        const parsed = SpaceConflictErrorUtil.parsePutError(error, locations);
        if (!parsed) return false;

        this.spaceConflictMessage.set(parsed.summary);
        this.displayConflicts.set(parsed.conflicts);
        this.cd.detectChanges();
        this.objectSearchModal?.close();
        void this.spaceConflictModal?.open();

        this.displayConflicts.set(
            await SpaceConflictErrorUtil.enrichWithAvailTimes(parsed.conflicts, {
                dates: S25ReservationUtil.getReservationsStartEndDates(reservations),
                eventId: this.eventId,
                profileId: this.profileId,
                fls: this.fls,
            }),
        );
        this.cd.detectChanges();
        return true;
    }

    setLoading(yes: boolean) {
        if (yes) {
            S25LoadingApi.init(this.elementRef.nativeElement);
        } else {
            S25LoadingApi.destroy(this.elementRef.nativeElement);
        }
        this.cd.detectChanges();
    }

    setSearchButtons() {
        const occState = this.occurrence()?.state;
        const spaceSearch = this.fls.SPACE_SEARCH;
        const resourceSearch = this.fls.RESOURCE_SEARCH;
        this.locSearchDisabled = occState === 99 || occState === 2 || !(["F", "R", "C"].indexOf(spaceSearch) > -1);
        this.resSearchDisabled = occState === 99 || occState === 2 || !(["F", "R", "C"].indexOf(resourceSearch) > -1);
    }

    ngOnDestroy() {
        if (this.selectedItemsSubscription) {
            this.selectedItemsSubscription.unsubscribe();
        }
    }
}
